import React from 'react'
import {BaseButton, Box, Flex, Text} from '../../vanilla'
import {Link} from '../link'
import {useBasketStore, useCustomerStore} from '../../store/hooks/useStore'
import {DeliveryBannerSlot} from '../cms/delivery-banner/DeliveryBannerSlot'
import {SlotContentItem} from '../../types/cms'
import { isMobile } from '../../utils/utils'
import {LocationIcon} from '../icons'

interface NoSelectedDeliveryProps {
  deliveryBanner?: SlotContentItem
}

export const NoSelectedDelivery = ({deliveryBanner}: NoSelectedDeliveryProps) => {
  const {isRegistered, primaryAddressDisplay} = useCustomerStore()
  const {addressDisplay} = useBasketStore()
  const deliveryAddressDisplay = addressDisplay || primaryAddressDisplay

  return (
    <Flex
      direction={['column', 'row']}
      alignItems={['stretch', 'center']}
      justifyContent="space-between"
      gap={['16px', '24px']}
      width="full"
    >
      <Box>
        {isRegistered ? (
          <>
            <Text variant="text4" display={['block', 'none']}>
              Welcome to Iceland
            </Text>
            <Text variant="text4" display={['none', 'block']}>
              Welcome to Iceland, book a delivery to get started
            </Text>
            {deliveryAddressDisplay && (
              <Flex gap="2px" align="flex-start" marginTop="2px">
                <LocationIcon
                  width="16px"
                  height="auto"
                  color="accent1"
                  flexShrink="0"
                  marginTop="2px"
                />
                <Text
                  as={Link}
                  href="/select-delivery"
                  variant="text3"
                  color="accent1"
                  textDecoration="underline"
                  data-test-selector="delivery-address-link"
                  data-cs-mask=""
                >
                  {deliveryAddressDisplay}
                </Text>
              </Flex>
            )}
          </>
        ) : (
          <>
            <Text variant="heading1" fontWeight="bold">
              Welcome to Iceland
            </Text>
            <Text variant="text4">
              Same Day Delivery and FREE Next Day Delivery slots available
            </Text>
          </>
        )}
      </Box>
      {deliveryBanner && isMobile() && (
        <DeliveryBannerSlot data={deliveryBanner} />
      )}
      <Flex direction={['column', 'row']} gap="12px">
        <BaseButton
          as={Link}
          href="/book-delivery"
          variant={isRegistered ? "primary" : "outlinePrimary"}
          width={['full', 'auto']}
          minWidth="150px"
        >
          <Text variant="unstyled" fontSize="inherit" fontWeight="inherit">
            Book Delivery
          </Text>
        </BaseButton>
        {!isRegistered && (
          <BaseButton
            as={Link}
            href="/login"
            variant="primary"
            width={['full', 'auto']}
            minWidth="150px"
          >
            <Text variant="unstyled" fontSize="inherit" fontWeight="inherit">
              Sign In
            </Text>
          </BaseButton>
        )}
      </Flex>
    </Flex>
  )
}
